import React from 'react';
import Icon from '../../../components/AppIcon';

const AutomationStatus = ({ queueData }) => {
  return (
    <div className="bg-card rounded-lg p-6 border border-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Automation Queue Status</h3>
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-success animate-pulse" />
          <span className="text-xs text-muted-foreground">Active</span>
        </div>
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
              <Icon name="CheckCircle" size={20} className="text-success" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Completed</p>
              <p className="text-xs text-muted-foreground">Last 24 hours</p>
            </div>
          </div>
          <span className="text-2xl font-bold text-success">{queueData?.completed}</span>
        </div>

        <div className="flex items-center justify-between p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-warning/10 flex items-center justify-center">
              <Icon name="Clock" size={20} className="text-warning" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Pending</p>
              <p className="text-xs text-muted-foreground">In queue</p>
            </div>
          </div>
          <span className="text-2xl font-bold text-warning">{queueData?.pending}</span>
        </div>

        <div className="flex items-center justify-between p-4 bg-muted/30 rounded-lg">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-error/10 flex items-center justify-center">
              <Icon name="AlertCircle" size={20} className="text-error" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Failed</p>
              <p className="text-xs text-muted-foreground">Requires attention</p>
            </div>
          </div>
          <span className="text-2xl font-bold text-error">{queueData?.failed}</span>
        </div>
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Success Rate</span>
          <span className="font-semibold text-success">{queueData?.successRate}%</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2 mt-2">
          <div
            className="bg-success h-2 rounded-full transition-all duration-300"
            style={{ width: `${queueData?.successRate}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default AutomationStatus;